import React from "react";
import { ActionIcon, AdventureIcon, AllIcon, CardIcon, EducationalIcon, PuzzleIcon, RacingIcon, SportIcon, StrategyIcon } from "./components/atoms/Icons";

export const filterList = [
    {
        icon: <AllIcon />,
        title: "All"
    },
    {
        icon: <AdventureIcon />,
        title: "Idle"
    },
    {
        icon: <StrategyIcon />,
        title: "Strategy"
    },
    {
        icon: <ActionIcon />,
        title: "Action"
    },
    {
        icon: <PuzzleIcon />,
        title: "Puzzle"
    },
    {
        icon: <EducationalIcon />,
        title: "Educational"
    },
    {
        icon: <SportIcon />,
        title: "Sport"
    },
    {
        icon: <CardIcon />,
        title: "Card"
    },
    {
        icon: <RacingIcon />,
        title: "Racing"
    },
];
